import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default async function destroyRecord(record, options = {}) {
  let { isNew } = record.currentState;

  record.deleteRecord();

  if (isNew) {
    return record;
  }

  record.errors.clear();

  await record.store.request(saveRecord(record, options));

  record.unloadRecord();

  return record;
}
